import { styled } from "@mui/material";
import LayoutConstants from "../../constants/LayoutConstants";

/** スタイルを適用したMainコンポーネント */
const StyledMain = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${LayoutConstants.SideMenuWidth}px`,
    // サイドメニューが開いているとき
    ...(open && {
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    }),
  }),
);

/** ヘッダーの分だけpaddingを挿入するためのコンポーネント */
const PaddingInsertion = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar
  }),
);

/** Main コンポーネント */
const Main = ({ open, children }) => {
  return (
    <StyledMain open={open}>
      <PaddingInsertion />
      {children}
    </StyledMain>
  );
};

export default Main;
